import { PageHeaderType, type LayoutSpec } from '../../../../types/LayoutConfig';
import { ORDER_BOOKS_LAYOUT_ID, ORDER_BOOKS_LAYOUT_TEMPLATE_ID } from '../tokens';
import { ORDER_BOOKS_LAYOUT } from './OrderBooks';

export const ORDER_BOOKS_LAYOUT_SPEC: LayoutSpec = {
  templateId: ORDER_BOOKS_LAYOUT_TEMPLATE_ID,
  label: 'Order books',
  id: ORDER_BOOKS_LAYOUT_ID,
  pageHeader: PageHeaderType.TradingDefault,
  dockViewLayout: ORDER_BOOKS_LAYOUT,
  constraints: [],
  collapsablePanels: [],
};
